<template>
  <div class="py-4 grid gap-4">
    <div class="flex justify-between items-center">
      <Label>
        Hide on Desktop
      </Label>

      <Toggle
        @change="handleChange('desktop')"
        :checked="getChecked('desktop')"
      />
    </div>

    <div class="flex justify-between items-center">
      <Label>
        Hide on Tablet
      </Label>

      <Toggle
        @change="handleChange('tablet')"
        :checked="getChecked('tablet')"
      />
    </div>

    <div class="flex justify-between items-center">
      <Label>
        Hide on Mobile
      </Label>

      <Toggle
        @change="handleChange('mobile')"
        :checked="getChecked('mobile')"
      />
    </div>
  </div>
</template>

<script>

import get from 'lodash/get'
import arrayToggle from '@converdy/utils/array-toggle'
import createControlMixin from './create-control-mixin'

export default {
  mixins: [ createControlMixin() ],

  methods: {
    handleChange (breakpoint, value) {
      this.Control.handleChange({
        propName: 'base.hideOn',
        value: arrayToggle(this.value, breakpoint)
      })
    },

    getChecked (breakpoint) {
      return this.value.includes(breakpoint)
    }
  }
}

</script>
